import { render, staticRenderFns } from "./FiltersInvoice.vue?vue&type=template&id=3735fb6e&scoped=true"
import script from "./FiltersInvoice.vue?vue&type=script&lang=js"
export * from "./FiltersInvoice.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&id=3735fb6e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3735fb6e",
  null
  
)

export default component.exports